// Helper único para todos los enlaces de WhatsApp del sistema.
// Elimina el bug "No se pudo abrir el enlace de este chat" causado por espacios,
// guiones, paréntesis, plus signs y numeros invalidos.

const MEXICO_CODE = "52";

/** Deja SOLO dígitos y garantiza código internacional. Devuelve null si es inválido. */
export function normalizarTelefono(raw) {
  if (raw == null) return null;
  const digitos = String(raw).replace(/\D+/g, "");
  if (!digitos) return null;
  // Longitudes esperadas: 10 (MX local), 11 (con 1 antiguo → descartar), 12 (52 + 10), 13+ (otro país)
  let normalizado = digitos;
  // Descartar el "1" mexicano legacy (52 1 XXXX...) que rompe wa.me
  if (normalizado.startsWith("521") && normalizado.length === 13) {
    normalizado = "52" + normalizado.slice(3);
  }
  // Si tiene 10 dígitos → asumir México
  if (normalizado.length === 10) {
    normalizado = MEXICO_CODE + normalizado;
  }
  // Si tiene 11 dígitos y empieza con 1 (US/CA), respeta
  // Si tiene < 10 dígitos es inválido
  if (normalizado.length < 10 || normalizado.length > 15) return null;
  return normalizado;
}

/** Devuelve la URL wa.me correcta o null si el teléfono es inválido. */
export function whatsappUrl(telefono, mensaje = "") {
  const num = normalizarTelefono(telefono);
  if (!num) return null;
  const base = `https://wa.me/${num}`;
  if (!mensaje) return base;
  return `${base}?text=${encodeURIComponent(mensaje)}`;
}

/** Handler onClick reutilizable — abre WhatsApp si el número es válido, si no muestra toast. */
export function abrirWhatsApp(telefono, mensaje = "", onInvalido = null) {
  const url = whatsappUrl(telefono, mensaje);
  if (!url) {
    if (typeof onInvalido === "function") onInvalido();
    return false;
  }
  window.open(url, "_blank", "noopener,noreferrer");
  return true;
}
